.app {
  display: flex;
  height: 100vh;
  flex-direction: column;
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

.main-content {
  flex: 1;
  padding: 1rem;
  max-width: 1200px;
  width: 100%;

  margin-top: var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
  margin-left: auto;
  margin-right: auto;
  overflow-y: auto;
}

.main-content-inner {
  height: 150px;
  background-color: var(--bg-secondary);
  padding: 20px;
}


